import { usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import { CloudAIAgentProtectionBlockPage } from '../../modules/aiAgentProtection/cloud/BlockPage/CloudAIAgentProtectionBlockPage';
import CloudAIAgentProtection from '../../modules/aiAgentProtection/cloud/CloudAIAgentProtection';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const CloudAiProtectionRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();
    const displayBlockPage = isPageBlocked(LAYOUT_TABS.AI_AGENT_PROTECTION_CLOUD.ID);

    return (
        <LogicalRoute
            {...props}
            blockPageComponent={CloudAIAgentProtectionBlockPage}
            component={CloudAIAgentProtection}
            displayBlockPage={displayBlockPage}
        />
    );
};
